module.exports = __webpack_public_path__ + "img/CARAC1.d7670357.jpg";